import { computed } from 'vue'
import { useCookies } from '@vueuse/integrations/useCookies'
export default function () {
  const hasAccepted = computed(() => {
    const cookies = useCookies(['cookieAccepted'])
    const hasAccepted = cookies.get('cookieAccepted')
    return hasAccepted ?? false
  })

  const setCookie = () => {
    const cookies = useCookies(['cookieAccepted'])
    cookies.set('cookieAccepted', true)
  }

  return { hasAccepted, setCookie }
}
